import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import ArbitrationTasksList from './ArbitrationTasksList';

export default ColumnsContent(ArbitrationTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/ArbitrationTasksList/index.js